import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";
import { openModalLogin } from "../aspirante/aspiranteDucks";

// Constantes
const dataInicial = {
  accessToken: null,
  refreshToken: null,
  nombre: null,
  apellidos: null,
  correo: null,
  idAspirante: null,
  estatusAcceso: null,
  cargandoInfo: null,
  indicadorError: null,
  messageError: null,
  autenticado: false,
  //########### Configuración del token ######################################
  isSesionActive: 0,
};

// types
const GET_LOGIN = "GET_LOGIN";
const SET_LOGIN_REFRESH = "SET_LOGIN_REFRESH";
const GET_LOGOUT = "GET_LOGOUT";
const GET_ERROR_LOGOUT = "GET_ERROR_LOGOUT";
const GET_ERROR_LOGIN = "GET_ERROR_LOGIN";
const GET_ERROR_NETWORK = "GET_ERROR_NETWORK";
const SET_NUEVOS_TOKENS = "SET_NUEVOS_TOKENS";
const UPDATE_ESTATUS_ACCESO = "UPDATE_ESTATUS_ACCESO";
const CLEAN_ERROR_LOGIN = "CLEAN_ERROR_LOGIN";

// Reducer
export default function usuarioReducer(state = dataInicial, action) {
  switch (action.type) {
    case GET_LOGIN:
      return {
        ...state,
        cargandoInfo: false,
        indicadorError: false,
        messageError: "Exitoso",
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        nombre: action.payload.nombreCompleto,
        apellidos: action.payload.apellidos,
        estatusAcceso: action.payload.estatusAcceso,
        correo: action.payload.correo,
        idAspirante: action.payload.idAspirante,
        autenticado: true,
        isSesionActive: 0,
      };

    case GET_ERROR_LOGIN:
      return {
        ...dataInicial,
        indicadorError: true,
        //########### Configuración del token ######################################
        isSesionActive: action.payload.tipoMensaje === "SESION_ACTIVA" ? 1 : 0,
        messageError: action.payload.mensaje,
      };
    case CLEAN_ERROR_LOGIN:
      return {
        ...dataInicial,
        indicadorError: false,
        messageError: null,
      };

    case GET_ERROR_NETWORK:
      return {
        ...dataInicial,
        indicadorError: true,
        messageError:
          "El sistema se encuentra fuera de servicio, favor de acceder más tarde.",
      };
    case GET_LOGOUT:
      return dataInicial;

    case GET_ERROR_LOGOUT:
      return {
        ...state,
        indicadorError: true,
        messageError: action.payload.mensaje,
      };

    case UPDATE_ESTATUS_ACCESO:
      return {
        ...state,
        estatusAcceso: action.payload,
      };

    case SET_LOGIN_REFRESH:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
      };
    default:
      return state;
  }
}

export const updateEstatus = (status) => ({
  type: UPDATE_ESTATUS_ACCESO,
  payload: status,
});

// Acciones
export const getUsuarioLogin =
  (usuario, password) => async (dispatch, getState) => {
    try {
      const urls = await axios(window.location.origin + JSON_URL);
      const { isSesionActive } = getState().usuarioLogin;
      const response = await axios.post(
        `${urls.data.urlServer}${urls.data.urlLogin}`,
        { usuario, password, isSesionActive }
      );
      dispatch({ type: GET_LOGIN, payload: response.data });
      dispatch(openModalLogin());
    } catch (error) {
      if (!error.response) {
        dispatch({ type: GET_ERROR_NETWORK });
      } else {
        // console.log(error.response.data)
        dispatch({ type: GET_ERROR_LOGIN, payload: error.response.data });
      }
    }
  };
export const getUsuarioRefresh = () => async (dispatch, getState) => {
  try {
    const { accessToken, refreshToken, correo } = getState().usuarioLogin;
    const urls = await axios(window.location.origin + JSON_URL);

    await axios
      .post(`${urls.data.urlServer}${urls.data.urlLoginRefresh}`, {
        accessToken,
        refreshToken,
        usuario: correo,
      })
      .then((resp) => {
        const { data } = resp;
        dispatch(setNewTokens(data));
      })
      .finally(() => {
        window.location.reload();
      });
  } catch (error) {
    if (!error.response) {
      dispatch({ type: GET_ERROR_NETWORK });
    } else {
      dispatch({ type: GET_ERROR_LOGIN, payload: error.response.data });
    }
  }
};

export const getUsuarioLogout = () => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios.post(
      urls.data.urlServer +
        urls.data.urlLogout +
        getState().usuarioLogin.accessToken
    );
    dispatch({ type: GET_LOGOUT, payload: response.data });
    // localStorage.removeItem('persist:root')
    // window.location.reload();
  } catch (error) {
    if (!error.response) {
      dispatch({ type: GET_ERROR_NETWORK });
    } else {
      dispatch({ type: GET_ERROR_LOGOUT, payload: error.response.data });
    }
  }
};

export const setNewTokens = (state) => ({
  type: SET_LOGIN_REFRESH,
  payload: state,
});
export const cleanErrorLogin = (state) => ({
  type: CLEAN_ERROR_LOGIN,
  payload: state,
});

export const cleanUsuario = () => async (dispatch) => {
  dispatch({ type: GET_LOGOUT });
};

export const cambiaTokens = (tokens) => async (dispatch) => {
  dispatch({
    type: SET_NUEVOS_TOKENS,
    payload: tokens,
  });
};
